import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import ReactPlayer from 'react-player';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import HtmlParser from 'html-react-parser';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import JoinHappyCustomers from '../components/JoinHappyCustomers';
import { Link } from 'react-scroll'
import { DemoFormShort } from '../components/DemoFormShort.jsx';
import { DemoFormLong } from '../components/DemoFormLong.jsx';
import MultimedialPanel from '../components/MultimedialPanel';
import FeaturedPress from '../components/FeaturedPress.js';
import Testimonials from  '../components/Testimonials.js';
import { PATHS } from '../utils/urls';

function HeroModal() {
	const [modalShow, setModalShow] = React.useState(false);

	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">Watch short video</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://youtu.be/R4X03e-66yI'
							playing
							volume={1}
							controls={true}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}


const Home = (props) => {
	const location = props.location;

	return (
		<Layout  bodyClass="page-home-index2" ontouchstart>
			<SEO title="ChartHop | People Analytics, Visualized" />
			<Helmet>
				<meta name="description" content="Automatically create and update org charts, build headcount plans and analyze all your people data - in one central hub, no spreadsheets needed."/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="ChartHop | People Analytics, Visualized" />
				<meta property="og:description" content="Automatically create and update org charts, build headcount plans and analyze all your people data - in one central hub, no spreadsheets needed." />
				<meta property="og:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:site_name" content="ChartHop" />
				<meta name="facebook-domain-verification" content="0773zjfi2h4cnhzn3lybdhl2ntcki6" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="ChartHop | People Analytics, Visualized" />
				<meta name="twitter:description" content="Automatically create and update org charts, build headcount plans and analyze all your people data - in one central hub, no spreadsheets needed." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
				<meta name="twitter:creator" content="@charthop" />

			</Helmet>
			<section className="intro container">
				<div className="row align-items-center">
					<div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
						<h1>People Analytics, Visualized.</h1>
						<h2 className="home-hero-subtitle">Make better people decisions.</h2>	
						<div>
							<DemoFormShort source={"home-page-demo-header"} />
							<HeroModal />
						</div>
					</div>
					<div className="reactPlayerContainer col-md-6 col-lg-6 order-md-1" >
						<img src="/img/hero_image.png" alt="hero"/>
					</div>
				</div>
			</section>

			{/* CUSTOMERS */}
			<section className="customer testimonial-container pt-8 pb-5 ">
				<JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
			</section >	
			
			{/* THE SOLUTION */}
			<section className="the-solution">
				<div className="container pt-3 pt-md-5 pb-5  ">

					{/* ANCHORS */}
					<div className="row align-items-center mb-2 mb-md-5 mb-lg-5">
						<div className="col-md-12 text-center">
							<div className="d-flex justify-content-between justify-content-sm-center">
								<Link to="Improve" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Improve org health</Link>
								<Link to="Align" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Drive alignment & accountability</Link>
								<Link to="Save" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Save time & money</Link>
							</div>
						</div>
					</div>

					{/* CENTRALIZE */}
					<div name="Improve" id="Improve" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							title="IMPROVE ORG HEALTH"
							link="/product/2105-refresh/org-chart.png"
							type="image"
							paddingClass="padding-top-video-1"
							content={
								<React.Fragment>
									<h2>Design your org - easily and intentionally.</h2>
									<p>Monitor the evolution of key metrics across the organization. </p>
									<p>Drive employee engagement & productivity with increased transparency and better communication. </p>
								</React.Fragment>
							}
						/>
					</div>

					{/* VISUALIZE */}
					<div name="Align" id="Align" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="right"
							title="DRIVE ALIGNMENT AND ACCOUNTABILITY"
							link="/product/2105-refresh/reports.png"
							type="image"
							paddingClass="padding-top-video-2"
							content={
								<React.Fragment>
									<h2>Facilitate collaboration & communication on every level </h2>
									<p> From HR & Finance teams to managers and recruiting -- finally, everyone is on the same page. </p>
									<p>Measure effectiveness of DEI programs and identify gaps. </p>
									<p>Conduct time-based audits with ease. </p>
								</React.Fragment>
							}
						/>
					</div>

					{/* SAVE */}
					<div name="Save" id="Save" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							title="SAVE TIME & MONEY"
							link="/product/people-analytics/Integration_reports-2.mp4"
							type="video"
							paddingClass="padding-top-video-3"
							content={
								<React.Fragment>
									<h2>Stop spending hours in spreadsheets & repetitive tasks</h2>
									<p>Streamline processes and data, without additional headcount. </p> 
									<p>Hire the right people at the right time with more efficient hiring plans.</p>
									<p>Reduce attrition by identifying risks early.</p>
								</React.Fragment>
							}
						/>
					</div>

				</div>
			</section>

			{/* AS FEATURED IN */}

			<FeaturedPress bgGrey backgroundGradientContainer />

			{/* YOUR FOCUS */}
			<section >
				<div className="container pt-3 pb-3 pt-md-6 pb-md-6">
					<div className="row align-items-center">

						<div className="col-md-8 col-lg-6 offset-lg-1 ">
							<h2 className="mb-2">You focus on your people. We'll focus on keeping your data safe.</h2>
							<p>You're entrusting ChartHop with your most valuable data, and we take this responsibility very seriously.</p>
							<div className="text-center d-block d-md-none d-block mr-auto ml-auto mt-4 mb-4">
								{/* <LazyLoad height={250} offset={100}  once={true}> */}
								<img src='/home/safety.svg' alt="Safety" className="" width="195" />
								{/* </LazyLoad> */}
							</div>
							<div className="container d-sm-flex">
								<ul className="col-md-6 pb-0 pr-3">
									<li>Complete SOC 2 Type 2 Examination</li>
									<li>Encryption at rest & in transit</li>
									<li>Biometric and physical-key two-factor access control</li>
								</ul>

								<ul className="col-md-6 pt-0 pr-3">
									<li>Mandatory SSO enforcement</li>
									<li>Employee auto-offboarding</li>
									<li>Customizable permission controls</li>
								</ul>


							</div>

						</div>

						<div className="reactPlayerContainer col-md-4 col-lg-3 offset-lg-1" >
							<img src='/home/safety.svg' alt="Safety" className="p-2 d-none d-md-block " />
						</div>
					</div>
				</div>
			</section>

			<Testimonials bgGrey />

			{/* REQUEST DEMO */}
			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
				<DemoFormLong source={"home-page-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-0 contact-testimonial-index2">"Planning and managing organizations, people growth and modeling org changes has been mostly manual until now - ChartHop makes it all happen in software."</p><div class="authorTag"><img src="/supporters/aileen-cowboy.png" class="testimonialAuthor" alt="Aileen Lee from Cowboy" /><div><p class="contactAuthor"><strong>Aileen Lee</strong> <br>Founder & Partner, Cowboy Ventures</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Home;